/**
 * What a host glTF needs to look as it does in legacy once it sits in the SDK's
 * splat scene: the legacy lights, and an opaque material.
 */
import * as THREE from 'three';
import type { EnvironmentConfig } from '../../sceneConfig';

/** Legacy `EnvironmentManager.addGlobalLight`: a splat-only SDK scene has no lights. */
export const addLegacyLights = (
  scene: THREE.Scene,
  environment: EnvironmentConfig,
): THREE.Light[] => {
  const { hemisphereLight, directionalLights } = environment;
  const lights: THREE.Light[] = [
    new THREE.HemisphereLight(
      hemisphereLight.skyColor,
      hemisphereLight.groundColor,
      hemisphereLight.intensity,
    ),
    ...directionalLights.map((light) => {
      const directional = new THREE.DirectionalLight(light.color, light.intensity);
      directional.position.set(light.position.x, light.position.y, light.position.z);
      return directional;
    }),
  ];
  scene.add(...lights);
  return lights;
};

/**
 * `crow.glb` is `alphaMode: BLEND`: a transparent bird sorts against the one
 * SparkRenderer object as a whole. Opaque with an alpha test lets depth do it.
 */
export const makeOpaque = (root: THREE.Object3D): void => {
  root.traverse((node) => {
    const mesh = node as THREE.Mesh;
    if (!mesh.isMesh) return;
    for (const material of Array.isArray(mesh.material) ? mesh.material : [mesh.material]) {
      material.transparent = false;
      material.depthWrite = true;
      material.alphaTest = 0.5;
      material.needsUpdate = true;
    }
  });
};
